import styled from 'styled-components';
import LoadingWrapper from '../../../CoreWrappers/LoadingWrapper';

export default styled(LoadingWrapper)`
	--gap: var(--spacing-x-large);
	display: flex;
	flex-direction: column;
	padding: var(--gap) 0;
	gap: var(--gap);
	flex: 1;

	.component-team-accounts {
		display: flex;
		gap: var(--px-8);
	}
`;
